import * as React from "react";
import styled from "styled-components";

const SvgCheck10 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 100 100" {...props}>
    <path d="M96.967 13.033c4.044 4.044 4.044 10.6 0 14.645l-49.29 59.289a10.316 10.316 0 01-6.71 3.015h-1.934a10.315 10.315 0 01-5.735-2.154l-.976-.861-29.289-29.29c-4.044-4.043-4.044-10.6 0-14.644 3.733-3.733 9.607-4.02 13.67-.861l.975.861L39.35 64.71l42.972-51.677c4.044-4.044 10.601-4.044 14.645 0z" />
  </svg>
);

export default styled(SvgCheck10)``;
